<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div
        :class="[size, height]"
        class="modal"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <header
          class="modal-header"
          v-if="!noHeader"
          id="modalTitle"
          :style="styleValue.back"
        >
          <slot name="header">This is the default title!</slot>
          <button
            type="button"
            class="btn-modalClose"
            :style="styleValue.white"
            @click="close"
          >
            <i class="fa fa-window-close"></i>
          </button>
        </header>
        <section
          class="modal-body"
          id="modalDescription"
          :style="styleValue.padding"
        >
          <button
            v-if="noHeader"
            type="button"
            class="btn-modalClose"
            :style="styleValue.white"
            @click="close"
          >
            <i class="fa fa-window-close"></i>
          </button>
          <slot name="body">I'm the default body!</slot>
        </section>
        <footer v-if="!noFooter" class="modal-footer">
          <slot name="footer">
            I'm the default footer!
            <button
              type="button"
              class="btn-green"
              @click="close"
              aria-label="Close modal"
            >
              Close me!
            </button>
          </slot>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "modal",
  props: {
    noHeader: {
      type: Boolean,
      default: false,
    },
    noFooter: {
      type: Boolean,
      default: false,
    },
    styleValue: {
      type: Object,
      default: () => ({
        back: "background-color=red",
      }),
    },
    size: {
      type: String,
      default: "w-25",
    },
    height: {
      type: String,
      default: "h-25",
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.btn-modalClose {
  position: absolute;
  left: 10px;
  top: 10px;
  background: none;
  border: none;
  font-size: 200%;
  color: blue;
  cursor: pointer;
}

.fa-close {
  cursor: pointer;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
  opacity: 1;
}
.modal {
  background: #ffffff;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  position: relative !important;
}
.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  border-bottom: 1px solid #eeeeee;
  color: #088a29;
  justify-content: space-between;
}

.modal-footer {
  border-top: 1px solid #eeeeee;
  justify-content: flex-end;
}

.modal-body {
  position: relative;
  /* max-height: 75%; */
  overflow-y: auto;
}

.btn-close {
  border: none;
  font-size: 20px;
  padding: 20px;
  cursor: pointer;
  font-weight: bold;
  color: #4aae9b;
  background: transparent;
}

.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}

.modal-fade-enter,
.modal-fade-leave-active {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s ease;
}

.small-modal {
  width: 600px;
}

.auto_height {
  height: auto;
  max-height: 80vh;
  overflow: auto;
}
.max-height-screen {
  max-height: 100%;
  overflow-y: auto;
}
.fixed-top {
  left: 0px !important;
  right: auto;
}
</style>
